import { stripQueryAndHash } from 'lib/utils/strip-query-and-hash';
import { PRODUCT_SKUS, ProductSku } from 'lib/constants/product-skus';

// SKUs sold on each storefront PDP path (the public rewrite source, not the
// /pdp/* file route — match against router.asPath). The first SKU is the
// page's primary product and anchors percentage-to-dollar promo comparisons;
// bundle pages list every product so a code entitled to any of them counts as
// applicable to the page. A test binds this map to the /pdp/* rewrites in
// next.config.js, so adding a PDP without updating it fails CI.
const PDP_ROUTE_SKUS: Record<string, ProductSku[]> = {
  '/daily-synbiotic': [PRODUCT_SKUS.DAILY_SYNBIOTIC],
  '/daily-synbiotic-refill': [PRODUCT_SKUS.DAILY_SYNBIOTIC_REFILL],
  '/energy-focus': [PRODUCT_SKUS.ENERGY_FOCUS],
  '/sleep-restore': [PRODUCT_SKUS.SLEEP_RESTORE],
  '/gut-reset': [PRODUCT_SKUS.GUT_RESET],
  '/daily-multivitamin': [PRODUCT_SKUS.DAILY_MULTIVITAMIN],
  '/vaginal-synbiotic': [PRODUCT_SKUS.VAGINAL_SYNBIOTIC],
  '/vaginal-synbiotic-sustain': [PRODUCT_SKUS.VAGINAL_SYNBIOTIC_SUSTAIN],
  '/pds08-daily-kids-probiotic': [PRODUCT_SKUS.PDS08_DAILY_KIDS_PROBIOTIC],
  '/pds08-daily-kids-probiotic-refill': [
    PRODUCT_SKUS.PDS08_DAILY_KIDS_PROBIOTIC_REFILL,
  ],
  '/daily-essentials-duo': [
    PRODUCT_SKUS.DAILY_SYNBIOTIC,
    PRODUCT_SKUS.DAILY_MULTIVITAMIN,
  ],
};

// Returns the SKUs for a PDP path (query string / hash ignored), or null when
// the path isn't a product page.
export const getPdpSkusForPath = (path: string): ProductSku[] | null =>
  PDP_ROUTE_SKUS[stripQueryAndHash(path)] ?? null;
